import { jsonMember, jsonObject } from 'typedjson';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { Nillable } from '@web/utils';
import { ProductType } from '@web/shared/module/shop';

@jsonObject
export class AdminSubscriptionItemResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug?: Nillable<string>;

  @jsonMember(String)
  public readonly type!: ProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(Number)
  public readonly unitPrice!: number;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;
}
